module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-15-6b6acedc5bcdac69c97244a6ed7fea8b.jpg";